<h3
  class="ui primary header"
  style="
    font-family: Roboto;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    text-align: left;
    color: #3f4395;
  "
>
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div
  class="ui vertical basic segment"
  *ngIf="success || error"
  appMargin
  marginB="10px"
>
  <esl-message-toast [(message)]="error"></esl-message-toast>
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
</div>

<div class="content">
  <div
    class="scroll-wrapper ui basic segment"
    appMargin="0"
    appPadding="0"
    [ngClass]="{ loading: pending || pendingArr.length }"
  >
    <ng-container>
      <div class="name_new">
        <h2>{{ documentTypeName }} documents</h2>
      </div>
      <form class="ui form">
        <div class="grouped fields">
          <div
            class="field"
            *ngFor="let doc of documents; let i = index"
            appMargin
            marginT="20px"
          >
            <sui-checkbox
              style="width: 100%; display: flex; align-items: center"
              name="timer"
              class="new-timer_new"
              [(ngModel)]="doc.document.checkbox"
              (ngModelChange)="onBoxChecked(doc.document)"
            >
              <div>
                <h2
                  style="
                    font-family: Roboto;
                    font-size: 12px;
                    font-weight: 700;
                    line-height: 12px;
                    text-align: left;
                    color: #505050;
                  "
                >
                  {{ documentTypeName }}
                </h2>
                <div class="linked_document">
                  <div class="contents">
                    <div class="content_name">
                      <div
                        style="
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                          width: 100%;
                        "
                      >
                        <div class="name">
                          <img src="assets/icons/document-text.svg" alt="" />
                          <h5>
                            {{ doc.document.documentName }}
                          </h5>
                        </div>
                        <div class="action_button">
                          <img
                            src="assets/icons/Frame 5492.svg"
                            suiPopup
                            [popupInverted]="true"
                            popupPlacement="bottom"
                            popupText="View"
                            (click)="viewDocument(doc.document)"
                            alt=""
                          />
                        </div>
                      </div>

                      <p class="paragraph">ADDED BY:</p>
                      <div class="information">
                        <div class="info">
                          <div class="flex">
                            <h4 style="width: 45%">
                              <img src="assets/icons/User.svg" alt="" />{{
                                doc.document.createdBy | createdBy
                              }}
                            </h4>
                            <h4>
                              <img src="assets/icons/Clock 2.svg" alt="" />
                              {{
                                doc.document.dateCreated
                                  | date: "d MMM, y h:mm a"
                              }}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </sui-checkbox>
          </div>
          <div
            *ngIf="documents && documents?.length < 1"
            style="width: 100%; margin: 0 auto"
            class="no-record"
          >
            <h3
              style="
                font-size: 16px;
                font-weight: 700;
                margin-top: 2.5rem;
                text-align: center;
              "
            >
              This section has no linked supporting document
            </h3>
            <p
              style="
                font-size: 12px;
                font-weight: 400;
                margin-top: 16px;
                text-align: center;
              "
            >
              Go to the Supporting Document Section and upload needed Document
            </p>
          </div>
        </div>
      </form>
      <div class="ui vertical basic segment">
        <div class="ui two column grid">
          <div class="column middle aligned">
            <div class="ui icon button" (click)="getAllDocumentTypes(1)">
              <i class="refresh icon"></i>
            </div>
            <a class="ui basic label">{{ totalItems }} Record(s)</a>
          </div>
          <div
            class="column right aligned pagination menu"
            style="margin-left: auto"
          >
            <sui-pagination
              class="small"
              [collectionSize]="totalItems"
              [pageSize]="rows"
              [maxSize]="maxSize"
              [hasEllipses]="false"
              [page]="currentPage"
              (pageChange)="nextPage($event)"
            >
            </sui-pagination>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="actions" style="background: transparent; border: none">
    <button class="ui primary button" (click)="modal.deny()" autofocus>
      Cancel
    </button>
    <button
      class="ui primary button"
      *ngIf="!isPending"
      [ngClass]="{ yellow: pending }"
      [disabled]="pending || !linkedDoc.length > 0"
      (click)="submit()"
      autofocus
    >
      Link
    </button>
  </div>
</div>
